import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import InputMask from "react-input-mask";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from "@mui/material/InputAdornment";
import {
  Box,
  Select,
  FormControl,
  MenuItem,
  Button,
  Typography,
  Container,
  Alert,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import moment from "moment"

//CUSTOM IMPORTS
import { save } from "./savefunctions";
import { validar } from "./validaciones";
import { getData } from "../../../../../services/library";
import * as api from "./api"
import Notify from "../../../../Notify";
import CM05FormContainer from "./components/ui/CM05FormContainer";
import TableHead from "./components/ui/TableHead";
import AvisoNoRegistraInscripciones from "./components/ui/AvisoNoRegistraInscripciones"
import AppBarDialog from "./components/ui/AppBar";
import DialogoIngresosBrutos from "./components/ui/DialogoIngresosBrutos";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogIIBB_Formulario(props) {
  const [clienteIIBB, setClienteIIBB] = useState(null); //Guarda las percepciones registradas en iibb_clientes (son las que no vienen por padron)
  const [clienteIIBBOriginal, setClienteIIBBOriginal] = useState(null);
  const [padronOriginal, setPadronOriginal] = useState(null);
  const [padronIIBB, setPadronIIBB] = useState(null); //Son las percepciones que vienen por padron
  const [provincias, setProvincias] = useState([{}]);
  const [notify, setNotify] = useState({
    open: false,
    severity: "",
    color: "",
    mensaje: "",
  });
  const [showAlertProxCiclo, setShowAlertProxCiclo] = useState();
  const [showCargaProxPeriodo, setShowCargaProxPeriodo] = useState();
  const [cicloFiscalActual, setCicloFiscalActual] = useState();
  const configConvenio = JSON.parse(props?.cliente?.config_convenio ?? "{}");

  const handleClose = () => {
    props.setOpen(false);
  };

  const setearClienteIIBB = (data) => {
    setClienteIIBB(data);
    setClienteIIBBOriginal(data);
  };

  const setearIIBBPadrones = (data) => {
    const deepCopy = JSON.parse(JSON.stringify(data));
    setPadronIIBB(data);
    setPadronOriginal(deepCopy);
  };

  useEffect(() => {
    getData("/provincias/iibbmanual", setProvincias);
    api.getIIBBPadrones(props.cliente.cuit, setearIIBBPadrones);
    api.getIIBBManual(props.cliente.cuit, setearClienteIIBB, setClienteIIBB);
    api.getCicloFiscalActual(setCicloFiscalActual);
  }, []);

  const almacenarImpuesto = () => {
    const values = [...clienteIIBB];
    values.push({
      cuit: props.cliente.cuit,
      percepcion: "",
      id_provincia: "",
      porcentaje_excencion: "",
      vto_excencion: "",
    });
    setClienteIIBB(values);
  };

  const deshacerAlmacenar = (index) => {
    const values = [...clienteIIBB];
    values.splice(index, 1);
    if (index === 0 && clienteIIBB.length === 1) {
      setClienteIIBB([
        {
          cuit: props.cliente.cuit,
          percepcion: "",
          id_provincia: "",
          fecha_vigencia_desde: "",
          porcentaje_excencion: "",
          vto_excencion: ""
        },
      ]);
    } else {
      setClienteIIBB(values);
    }
  };

  const handleInputChange = (index, event) => {
    const values = [...clienteIIBB];
    const updatedValue = event.target.name;
    values[index][updatedValue] = event.target.value;
    setClienteIIBB(values);
  };

  const handlePadronIIBBExc = (index, event, provincia) => {
    const values = [...padronIIBB];
    const updatedValue = event.target.name;
    values[index][updatedValue] = event.target.value;
    setPadronIIBB(values);
  };

  const removerExcencion = (index) => {
    const values = [...padronIIBB];
    values[index].porcentaje_excencion = "";
    values[index].vto_excencion = "";
    setPadronIIBB(values);
  };

  async function preparar(e) {
    e.preventDefault();

    const excencionesPadronEliminadas = padronOriginal
      .filter((itemOriginal, index) => {
        const itemIIBB = padronIIBB[index];
        return (
          (itemOriginal.porcentaje_excencion &&
            !itemIIBB.porcentaje_excencion) ||
          (itemOriginal.vto_excencion && !itemIIBB.vto_excencion)
        );
      })
      .map((item) => ({
        id_provincia: item.id_provincia,
        cuit: String(props.cliente.cuit).trim(),

      }));

    const reqBody = {
      excencionesDePadron:
        padronIIBB
          .filter(
            (registro) =>
              !!registro.id_provincia &&
              (!!registro.porcentaje_excencion || !!registro.vto_excencion)
          )
          .map((registro) => {
            return {
              cuit: String(props.cliente.cuit).trim(),
              cuit_limpio: String(props.cliente.cuit).replace(/\D/g, ""),
              id_provincia: registro.id_provincia,
              porcentaje_excencion: registro.porcentaje_excencion || null,
              vto_excencion: registro.vto_excencion || null,
            };
          }) || [],
      excencionesFueraPadron:
        clienteIIBB.map((registro) => {
          return {
            cuit: String(props.cliente.cuit).trim(),
            cuit_limpio: String(props.cliente.cuit).replace(/\D/g, ""),
            id_provincia: registro.id_provincia,
            porcentaje_excencion: registro.porcentaje_excencion || null,
            vto_excencion: registro.vto_excencion || null,
          };
        }) || [],
      clienteIIBB:
        clienteIIBB
          .filter(
            (registro) =>
              !!registro.id_provincia ||
              !!registro.percepcion ||
              !!registro.porcentaje_excencion ||
              !!registro.vto_excencion
          )
          .map((registro) => {
            return {
              cuit: String(props.cliente.cuit).trim(),
              cuit_limpio: String(props.cliente.cuit).replace(/\D/g, ""),
              percepcion: registro.percepcion,
              id_provincia: registro.id_provincia,
              fecha_vigencia_desde: registro.fecha_vigencia_desde,
            };
          }) || [],
      eliminados:
        (clienteIIBBOriginal &&
          clienteIIBBOriginal.filter(
            (clienteOriginal) =>
              !clienteIIBB.find(
                (cliente) =>
                  String(cliente.cuit).trim() ===
                  String(clienteOriginal.cuit).trim() &&
                  cliente.id_provincia === clienteOriginal.id_provincia
              )
          )) ||
        [],
      excencionesPadronEliminadas: excencionesPadronEliminadas,
      user:localStorage.getItem("user"),
      clienteCuit:String(props.cliente.cuit).replace(/\D/g, "")   
    };

    const errores = validar(
      reqBody.clienteIIBB,
      reqBody.excencionesDePadron,
      reqBody.excencionesFueraPadron
    );
    if (errores.length > 0) {
      alert(errores.join("\n"));
    } else {
      save(reqBody, setNotify);
    }
  }

  const inputProps = {
    disableUnderline: true,
    sx: {
      paddingTop: 0,
      paddingBottom: 0,
      height: "32px",
    },
  };

  const inputsx = {
    ".MuiFilledInput-root": {
      paddingTop: 0,
      paddingBottom: 0,
      height: "32px",
    },
    ".MuiInputBase-input": {
      paddingTop: "6px",
      paddingBottom: "6px",
    },
  };

  useEffect(() => {
    if (cicloFiscalActual) {
      const existeConvenio = Object.values(configConvenio)?.length > 0;
      const hoy = moment().startOf('day')
      const vto = moment(cicloFiscalActual.fecha_vto, "YYYY-MM-DD").startOf('day');
      const mesesAnticipacion = Number(cicloFiscalActual.meses_anticipacion);
      const fechaAviso = vto.clone().subtract(mesesAnticipacion, "months").startOf("day");
      const showAviso = ((hoy.isSameOrAfter(fechaAviso) && hoy.isSameOrBefore(vto)) && (Number(configConvenio?.max_inscripciones) > 0 ))
      setShowAlertProxCiclo(showAviso)
    }
  }, [cicloFiscalActual])

  const columnSizes = {
    provincia: 4,
    inicio: 1.5,
    coeficiente_unificado: 1,
    fin: 1,
    coeficienteUnificado: 1,
    percepcion: 1,
    exencion: 1,
    vtoExencion: 1.5,
    acciones: 1,
  }

  const Children = (
    <Grid container>
      {
       showAlertProxCiclo &&
       <Box sx={{m:2}} width="100%">
         <Alert
           severity="info"
           action={
             <Button color="inherit" size="small" onClick={() => setShowCargaProxPeriodo(true)}>
               Cargar
            </Button>
           }
         >
           Ya está disponible la carga del próximo CM05
         </Alert>
       </Box>
     }
      <TableHead columnSizes={columnSizes} showExclusiones={true} showFin={false} showInicio={true} showCoeficienteUnificado={false} />
      {padronIIBB && clienteIIBB ? (
        <>
          <form style={{ width: "100%" }}>
            <Grid item xs={12}>
              {padronIIBB &&
                padronIIBB.map((field, index) => (
                  <>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                      p={1}
                      backgroundColor="#fff"
                      mt={1}
                      borderRadius={1}
                    >
                      <Grid
                        item
                        xs={4}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <LocationOnIcon color="primary" />
                        <Typography variant="subtitle" color="initial">
                          {field.cod_ddjj} - {field.provincia}
                        </Typography>
                      </Grid>
                      <Grid item xs={1.5}>
                        <Typography variant="subtitle" color="initial">
                          {moment(field.fecha_vigencia_desde).format("DD-MM-YYYY")}
                        </Typography>
                      </Grid>

                      <Grid item xs={1}>
                        <Typography
                          variant="subtitle"
                          sx={{ fontSize: 15 }}
                          color="initial"
                        >
                          {field.percepcion}
                        </Typography>
                      </Grid>

                      <Grid item xs={1}>
                        <TextField
                          value={field.porcentaje_excencion}
                          onChange={(e) => handlePadronIIBBExc(index, e)}
                          style={{
                            backgroundColor:
                              field.porcentaje_excencion > 100 ||
                                field.porcentaje_excencion === "0" ||
                                field.porcentaje_excencion === "00" ||
                                field.porcentaje_excencion === "000"
                                ? "#fadbd8"
                                : "#fff",
                            borderTopLeftRadius: 4,
                            borderTopRightRadius: 4,
                          }}
                          variant="filled"
                          size="small"
                          fullWidth
                          name="porcentaje_excencion"
                          InputProps={{
                            ...inputProps,
                            startAdornment: (
                              <InputAdornment
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "auto",
                                  marginBottom: "auto",
                                  marginRight: 1,
                                }}
                              >
                                <Typography
                                  variant="subtitle1"
                                  color={
                                    field.porcentaje_excencion > 100 ||
                                      field.porcentaje_excencion === "0" ||
                                      field.porcentaje_excencion === "00" ||
                                      field.porcentaje_excencion === "000"
                                      ? "error"
                                      : "primary"
                                  }
                                >
                                  %
                                </Typography>
                              </InputAdornment>
                            ),
                          }}
                          sx={inputsx}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          inputProps={{
                            maxLength: 3,
                          }}
                          type="text"
                        />
                      </Grid>
                      <Grid item xs={1.5}>
                        <TextField
                          variant="filled"
                          size="small"
                          fullWidth
                          type="date"
                          name="vto_excencion"
                          value={field.vto_excencion}
                          onChange={(e) =>
                            handlePadronIIBBExc(index, e, field)
                          }
                          InputProps={inputProps}
                          sx={inputsx}
                        />
                      </Grid>
                      {!!field.vto_excencion ||
                        !!field.porcentaje_excencion ? (
                        <Grid item xs={1}>
                          <Tooltip title="Quitar Excención">
                            <IconButton
                              onClick={() => removerExcencion(index)}
                              sx={{ p: 0.5 }}
                            >
                              <ClearIcon color="warning" />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      ) : (
                        <Grid item xs={1}></Grid>
                      )}
                    </Grid>
                  </>
                ))}
            </Grid>
            <Grid item xs={12}>
              {clienteIIBB &&
                clienteIIBB.map((field, index) => (
                  <>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                      p={1}
                      backgroundColor="#fff"
                      mt={1}
                      borderRadius={1}
                      direction="row"
                    >
                      <Grid
                        item
                        xs={4}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <LocationOnIcon color="primary" />
                        {provincias && (
                          <FormControl fullWidth>
                            <Select
                              disabled={!!field.id_provincia}
                              variant="filled"
                              size="small"
                              value={field.id_provincia}
                              onChange={(e) => {
                                const inputMask=provincias && JSON.parse((provincias?.find(prov=>prov.id === e.target.value)?.ui_config))?.input_mask || "9.99"
                                const values = [...clienteIIBB];
                                values[index]["id_provincia"] = e.target.value;
                                values[index]["inputMaskPercepcion"] = inputMask;
                                setClienteIIBB(values);
                              }}
                              name="id_provincia"
                              sx={{
                                ...inputsx,
                                height: "32px",
                                "&:before": {
                                  borderBottom: "none",
                                },
                                "&:hover:not(.Mui-disabled):before": {
                                  borderBottom: "none",
                                },
                                "&:after": {
                                  borderBottom: "none",
                                },
                              }}
                            >
                              {provincias.map((provincia) => {
                                const isDisabled = clienteIIBB.some(
                                  (item) =>
                                    item.id_provincia === provincia.id
                                );

                                return (
                                  <MenuItem
                                    key={provincia.id}
                                    value={provincia.id}
                                    disabled={isDisabled}
                                  >
                                    {provincia.cod_ddjj} - {provincia.provincia}{" "}
                                    {provincia.iibb_auto === 1
                                      ? "(Padrón)"
                                      : ""}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        )}
                      </Grid>
                      <Grid item xs={1.5}>
                        <TextField
                          variant="filled"
                          size="small"
                          fullWidth
                          type="date"
                          name="fecha_vigencia_desde"
                          value={field.fecha_vigencia_desde}
                          onChange={(e) => handleInputChange(index, e)}
                          InputProps={inputProps}
                          sx={inputsx}
                        />
                      </Grid>
                      <Grid item xs={1}>
                        <InputMask
                          mask={field.inputMaskPercepcion || "9.9999"}
                          value={field.percepcion}
                          maskChar="0"
                          onChange={(e) => handleInputChange(index, e)}
                        >
                          {() => (
                            <TextField
                              variant="filled"
                              size="small"
                              fullWidth
                              name="percepcion"
                              InputProps={inputProps}
                              sx={inputsx}
                            />
                          )}
                        </InputMask>
                      </Grid>
                      <Grid item xs={1}>
                        <TextField
                          disabled={
                            !field.percepcion || !field.id_provincia
                          }
                          value={field.porcentaje_excencion}
                          onChange={(e) => handleInputChange(index, e)}
                          variant="filled"
                          size="small"
                          fullWidth
                          name="porcentaje_excencion"
                          style={{
                            backgroundColor:
                              field.porcentaje_excencion > 100 ||
                                field.porcentaje_excencion === "0" ||
                                field.porcentaje_excencion === "00" ||
                                field.porcentaje_excencion === "000"
                                ? "#fadbd8"
                                : "#fff",
                            borderTopLeftRadius: 4,
                            borderTopRightRadius: 4,
                          }}
                          InputProps={{
                            ...inputProps,
                            startAdornment: (
                              <InputAdornment
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "auto",
                                  marginBottom: "auto",
                                  marginRight: 1,
                                }}
                              >
                                <Typography
                                  variant="subtitle1"
                                  color={
                                    field.porcentaje_excencion > 100 ||
                                      field.porcentaje_excencion === "0" ||
                                      field.porcentaje_excencion === "00" ||
                                      field.porcentaje_excencion === "000"
                                      ? "error"
                                      : "primary"
                                  }
                                >
                                  %
                                </Typography>
                              </InputAdornment>
                            ),
                          }}
                          sx={inputsx}
                        />
                      </Grid>
                      <Grid item xs={1.5}>
                        <TextField
                          disabled={
                            !field.percepcion || !field.id_provincia
                          }
                          variant="filled"
                          size="small"
                          fullWidth
                          label=""
                          type="date"
                          name="vto_excencion"
                          value={field.vto_excencion}
                          onChange={(e) => handleInputChange(index, e)}
                          InputProps={inputProps}
                          sx={inputsx}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          pr: 3,
                        }}
                      >
                        <Tooltip title="Eliminar IIBB">
                          <IconButton
                            onClick={() => deshacerAlmacenar(index)}
                            color="error"
                            sx={{ p: 0.5 }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                        {index === clienteIIBB.length - 1 && (
                          <Tooltip title="Agregar IIBB">
                            <IconButton
                              onClick={() => almacenarImpuesto()}
                              color="success"
                              sx={{ p: 0.5 }}
                            >
                              <AddCircleOutlineIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Grid>
                    </Grid>
                  </>
                ))}
            </Grid>
          </form>
        </>
      ) : (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs>
            <Typography m={4} fontSize={22} variant="h2" color="initial">
              Cargando impuestos..
            </Typography>
          </Grid>
          <Grid item>
            <CircularProgress color="primary" />
          </Grid>
        </Grid>
      )}
    </Grid>
  )
  //   {/* ) : (
  //       <AvisoNoRegistraInscripciones />
  //     )
  //   }  */}
  // </Container>

  return (
    <div>
      <DialogoIngresosBrutos 
        open={props?.open}
        handleClose={handleClose}
        cliente={props?.cliente}
        preparar={preparar}
      >
        {Children}
      </DialogoIngresosBrutos>
      {notify.open ? (
        <Notify
          open={notify.open}
          color={notify.color}
          severity={notify.severity}
          mensaje={notify.mensaje}
          handleClose={() => handleClose()}
        />
      ) : null}
      {
        showCargaProxPeriodo && (
          <CM05FormContainer
            open={showCargaProxPeriodo}
            setOpen={setShowCargaProxPeriodo}
            cliente={props.cliente}
            cicloActual={cicloFiscalActual}
            configConvenio={configConvenio}
          />
        )
      }
    </div>
  );
}

export default DialogIIBB_Formulario;

/*
    1- en la consulta de padrones, agregar filtro de fecha par tomar los del mes en transcurso
    2- agregar validaciones en textfields: porcentajes, fechas, solo ingreso de numeros, lo que sea necesario
    3- no poder cargar mas de una vez una percepcion de impuesto. es decir, no repetir la provincia del iibb. en backend, que primero busque si no existe un registro con ese cuit y esa provincia para ver si está cargado ese impuesto y en caso de que esté cargado, que lo modifique. tambien puede que lo busque con el id porque la tabla de iibb_clientes,no  va a cambiar todos los meses como la de padrones.
    4- verificar que cuando uno las dos tablas (iibb_clientes e iibb_excenciones), no haya mas de un registro de la excencion por impuesto :)
    5- ver que sucede si borro una percepcion de iibb (tanto con el registro de iibb_clientes, como el de iibb_excenciones)
    6- unir padrones con excenciones
    7- las consultas a padrones tardan 250 millones de años
*/


// const getCicloFiscalActual= async()=>{
//   await fetch (`${UrlApi}/impuestos/iibb_ciclos_fiscales/actual`)
//   .then(data=>data.json())
//   .then(data=>setCicloFiscalActual(data))
// }

//agregar que ignore los que tienen periodo. o sea where id_ciclo_fiscal is null
// const obtenerIIBBManual = () => {
//   fetch(UrlApi + "/iibb_clientes/cuit/" + props.cliente.cuit)
//     .then((data) => data.json())
//     .then((data) => {
//       data.length > 0
//         ? setearClienteIIBB(data)
//         : setClienteIIBB([
//           {
//             cuit: props.cliente.cuit,
//             percepcion: "",
//             id_provincia: "",
//             fecha_vigencia_desde: ""
//           },
//         ]);
//     });
// };

// const obtenerRegPadrones = () => {
//   fetch(UrlApi + "/padron/cliente/" + props.cliente.cuit)
//     .then((data) => data.json())
//     .then((data) => setearIIBBPadrones(data));
// };

// onChange={(e) =>{
//   const values = [...clienteIIBB];
//   // const updatedValue = e.target.name;
//   values[index]["id_provincia"] = e.target.value;
//   // values[index]["percepcion"] = provincias.find((prov)=>prov.id == e.target.value)?.percepcion || 0;
//   setClienteIIBB(values);
// }}
